import React from 'react';
import { observer } from 'mobx-react';
import PlacementTestReportStudentsListFilter from './PlacementTestReportStudentsListFilter';
import placementTestReportFilterService from '../services/PlacementTestReportFilterService';

class PlacementTestReportStudentsListFilterContainer extends React.Component {
  componentDidMount() {
    placementTestReportFilterService.handleSearchStudents();
  }

  render() {
    return (
      <PlacementTestReportStudentsListFilter
        onChange={placementTestReportFilterService.form.setValue}
        values={placementTestReportFilterService.form.getValues()}
        onSearch={placementTestReportFilterService.handleSearchStudents}
      />
    );
  }
}

export default observer(PlacementTestReportStudentsListFilterContainer);
